var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!_vm.entered && _vm.newFormCreated)?_c('enter-screen',{on:{"enter":_vm.onEnter}}):_c('call-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }